import { z } from "zod";

/**
 * Phase 2 (Pfad A) — LV-Extraktion aus Excel/PDF/GAEB.
 * `provisional: false` weil die Mengen direkt vom Kunden kommen.
 */
export const LVPositionSchema = z.object({
  oz: z.string(),
  originaltext: z.string(),
  kurzText: z.string().optional(),
  menge: z.number(),
  einheit: z.string(),
  provisional: z.boolean().default(false),
  hauptgruppe: z.string().optional(),
  /**
   * Pfad B / #5B — Wohneinheit-Tag, das von der gezeichneten Raum-Zuordnung
   * (`MengenRoom.wohneinheit`, #5A) über die Synthese hierher propagiert wird
   * und durch die (Pass-Through-)Konsolidierung bis in den Angebots-Export
   * trägt, wo die Positionen nach Wohneinheit gegliedert werden. Rein
   * organisatorisch — keine Mengen-/Preis-Wirkung. Leer = keiner WE zugeordnet.
   */
  wohneinheit: z.string().optional(),
  /**
   * Pfad B: In der Bemusterung (Raum-Detail-Modal) explizit gewählter
   * Kundenartikel-Code für dieses Bauteil. Fließt von synthesizeVorLvFromMengen
   * über die (Pass-Through-)Konsolidierung in den Match, wo er als gesetzter
   * Kandidat mit Vorrang geführt + als gewaehlterArtikel vorbelegt wird.
   * NIE in matchScore mergen — eigene Achse (Innendienst-Entscheidung).
   */
  vorausgewaehlterArtikelCode: z.string().optional(),
  metadata: z.object({
    sourceFile: z.string(),
    sourcePage: z.number().int().nonnegative().optional(),
    sourceRow: z.number().int().nonnegative().optional(),
    /**
     * Pfad B / #7 Fork A — maschinenlesbarer Anker einer Konstruktions-Position
     * aus einer gezeichneten Wand (statt nur im `originaltext`). Hängt der Wand
     * den zugeordneten Konstruktions-Code an, damit später OHNE Änderung der
     * Synthese angedockt werden kann:
     *  - ein Set/Schnellkalk-Template pro Code (Rigips + Unterkonstruktion +
     *    Spachtel + Schrauben mit m²-Faktoren), bzw.
     *  - weitere Gewerke als Konstruktion (Erweiterung in assignWallConstructionCode).
     */
    wandKonstruktion: z
      .object({
        code: z.string(),
        fullCode: z.string(),
        dickeMm: z.number(),
        bauweise: z.string(),
        confidence: z.number(),
      })
      .optional(),
  }),
});
export type LVPosition = z.infer<typeof LVPositionSchema>;

export const LVPositionenSchema = z.object({
  schemaVersion: z.literal(1).default(1),
  pfad: z.literal("A"),
  positionen: z.array(LVPositionSchema).default([]),
});
export type LVPositionen = z.infer<typeof LVPositionenSchema>;
